import React, { useState } from "react";
import api from "../../../api/axios";
import toast from "react-hot-toast";
import { Save, ImagePlus, Loader2 } from "lucide-react";

export default function ReferenceManager() {
  const [formData, setFormData] = useState({
    name: "", url: "", logo: null, preview: "",
  });
  const [saving, setSaving] = useState(false);

  const handleFileChange = (e) => {
    const f = e.target.files[0];
    if (f) {
      setFormData({ ...formData, logo: f });
      const reader = new FileReader();
      reader.onload = (ev) => setFormData((p) => ({ ...p, preview: ev.target.result }));
      reader.readAsDataURL(f);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) return toast.error("Firma adı gerekli");
    setSaving(true);

    const data = new FormData();
    data.append("dto.ReferenceName", formData.name);
    data.append("dto.ReferenceUrl", formData.url);
    if (formData.logo) data.append("file", formData.logo);

    try {
      await api.post("/reference", data, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Referans eklendi");
      setFormData({ name: "", url: "", logo: null, preview: "" });
    } catch { toast.error("Referans eklenemedi"); }
    finally { setSaving(false); }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h2>Referans Ekle</h2>
          <p className="page-subtitle">Yeni referans firması ekleyin</p>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="content-card" style={{ maxWidth: 600 }}>
          <div className="image-upload-area">
            {formData.preview ? (
              <div className="image-preview logo-preview">
                <img src={formData.preview} alt="Logo" />
                <button type="button" className="remove-image" onClick={() => setFormData((p) => ({ ...p, logo: null, preview: "" }))}>×</button>
              </div>
            ) : (
              <label className="upload-placeholder">
                <ImagePlus size={32} />
                <span>Logo Yükle</span>
                <input type="file" accept="image/*" onChange={handleFileChange} hidden />
              </label>
            )}
          </div>

          <div className="form-field">
            <label>Firma Adı</label>
            <input type="text" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} className="form-input" placeholder="Firma adı" />
          </div>

          <div className="form-field">
            <label>Website URL</label>
            <input type="url" value={formData.url} onChange={(e) => setFormData({ ...formData, url: e.target.value })} className="form-input" placeholder="https://example.com" />
          </div>

          <button type="submit" className="btn btn-primary btn-full" disabled={saving}>
            {saving ? <><Loader2 size={18} className="spin" /> Kaydediliyor...</> : <><Save size={18} /> Kaydet</>}
          </button>
        </div>
      </form>
    </div>
  );
}
